import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'react-modal';
import useMediaQueries from '@stone/hooks/useMediaQueries';
import Image from '@stone/ui/image/Image';
const appElement = document.getElementById('maincontent');
Modal.setAppElement(appElement ? appElement : document.getElementsByTagName('body')[0]);
const ModalDialog = (props) => {
    var _a;
    const { t } = useTranslation();
    const closeButton = () => {
        return (React.createElement("button", { type: "button", "aria-label": t('button.close'), className: classNames('modal__close', props.closeInvertedSm && 'modal__close--inverted-sm'), onClick: (e) => {
                e.stopPropagation();
                props === null || props === void 0 ? void 0 : props.onRequestClose(e);
            } }));
    };
    const { isMobile } = useMediaQueries();
    const renderHeader = () => (React.createElement(React.Fragment, null, !props.hideHeader && (React.createElement("div", { className: "modal__header" },
        props.buttonInHeader && closeButton(),
        props.beforeTitleButtons || props.afterTitleButtons ? (React.createElement("div", { className: "modal__header-title" },
            props.beforeTitleButtons,
            React.createElement("h2", { id: "dialog1_label", className: classNames('dialog__title', props.visuallyhidden && 'visually-hidden') }, props.contentLabel),
            props.afterTitleButtons)) : (React.createElement("h2", { id: "dialog1_label", className: classNames('dialog__title', props.visuallyhidden && 'visually-hidden') }, props.contentLabel)),
        props.subjsx && props.subjsx(),
        props.subtitle && React.createElement("p", { className: "dialog__description" }, props.subtitle)))));
    const renderChildren = () => props.image && !isMobile ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "modal__body--left" },
            React.createElement(Image, { src: props.image, alt: "" })),
        React.createElement("div", { className: "modal__body--right" },
            React.createElement("div", { className: "scrollable" },
                renderHeader(),
                props.children)))) : (props.children);
    return (React.createElement(Modal, Object.assign({ "aria-labelledby": props.contentLabel ? 'dialog1_label' : '', closeTimeoutMS: 600 }, props, { overlayClassName: classNames('overlay-modal', props.overlayClassName), className: classNames('modal modal--dialog', props.noPadding && 'modal--no-padding', (_a = props.className) === null || _a === void 0 ? void 0 : _a.toString().replace('modal--centered', ''), {
            'modal--fullheight': props.fullHeight,
            'modal--fullwidth': props.fullWidth,
            'modal--image': props.image,
            modal__legacy: props.isLegacy,
        }) }), props.noSkin ? (React.createElement(React.Fragment, null,
        !props.buttonInHeader && !props.hideCloseButton && closeButton(),
        renderChildren())) : (React.createElement("div", { className: classNames({ container: !props.fullWidth || !isMobile }) },
        React.createElement("div", { className: classNames({ 'row justify-center': !props.fullWidth || !isMobile, 'align-middle': !props.fullWidth || !isMobile }) },
            React.createElement("div", { className: "modal__closearea", onClick: (e) => {
                    e.stopPropagation();
                    props === null || props === void 0 ? void 0 : props.onRequestClose(e);
                }, "aria-hidden": "true" }),
            React.createElement("div", { className: classNames({ col: isMobile && !props.fullWidth }, 'modal__wrapper', { 'modal__legacy-wrapper': props.isLegacy }) },
                React.createElement("div", { className: "modal__container" },
                    React.createElement("div", { className: classNames('modal__content', { container: isMobile }) },
                        !props.buttonInHeader && closeButton(),
                        (!props.image || isMobile) && renderHeader(),
                        props.hasDivisor && React.createElement("hr", { className: "modal__divisor" }),
                        React.createElement("div", { className: "modal__body" }, renderChildren())))))))));
};
export default ModalDialog;
